import { getApplicationSettings } from "owa-application-settings";

export function is3PCustomPropertiesEnabled(): boolean {
    return getApplicationSettings("LivePersonaCard").thirdPartyCustomProperties;
}
